import { FlexCenVer, FlexColCenVer } from '@/UI/styles';
import { Scrubber } from '@/UI/VideoAudio/Scrubber/Scrubber';
import { EditableTimeInput } from './EditableTimeInput';
import { FrameStepButton } from './FrameStepButton';
import { PlayPauseButton } from './PlayPauseButton';
import { SoundButton } from './SoundButton';
import type { MediaPlayerControlsProps } from './types';

const slotWidth = 100;
const rowHeight = 24;
const glyphSize = 17;
const playheadHeight = 10;

export function CompactMediaPlayerControls({
  currentTime,
  duration,
  fps,
  isPaused: paused,
  isMuted: muted,
  hasAudio,
  onTogglePlay,
  onSetTime,
  onToggleMute,
}: MediaPlayerControlsProps) {
  return (
    <FlexColCenVer sx={{ gap: 1.5, py: 2, width: '100%' }}>
      <Scrubber duration={duration} setTime={onSetTime} time={currentTime} playheadHeight={playheadHeight} />

      <FlexCenVer sx={{ justifyContent: 'space-between', height: `${rowHeight}px`, px: 0.5, width: '100%' }}>
        <FlexCenVer sx={{ gap: 1, width: `${slotWidth}px` }}>
          <EditableTimeInput
            currentTime={currentTime}
            duration={duration}
            fps={fps}
            paused={paused}
            onTogglePlay={onTogglePlay}
            onSetTime={onSetTime}
          />
        </FlexCenVer>

        <FlexCenVer sx={{ gap: 1 }}>
          <FrameStepButton
            direction="back"
            currentTime={currentTime}
            duration={duration}
            fps={fps}
            paused={paused}
            onTogglePlay={onTogglePlay}
            onSetTime={onSetTime}
            width={rowHeight}
            height={rowHeight}
            btnW={glyphSize}
            btnH={glyphSize}
          />
          <PlayPauseButton
            onTogglePlay={onTogglePlay}
            paused={paused}
            width={rowHeight}
            height={rowHeight}
            btnW={glyphSize}
            btnH={glyphSize}
          />
          <FrameStepButton
            direction="forward"
            currentTime={currentTime}
            duration={duration}
            fps={fps}
            paused={paused}
            onTogglePlay={onTogglePlay}
            onSetTime={onSetTime}
            width={rowHeight}
            height={rowHeight}
            btnW={glyphSize}
            btnH={glyphSize}
          />
        </FlexCenVer>

        <FlexCenVer sx={{ width: `${slotWidth}px`, justifyContent: 'flex-end' }}>
          <SoundButton
            onToggleMute={onToggleMute}
            hasAudio={hasAudio}
            muted={muted}
            width={rowHeight}
            height={rowHeight}
            btnW={glyphSize}
            btnH={glyphSize}
          />
        </FlexCenVer>
      </FlexCenVer>
    </FlexColCenVer>
  );
}
